import { action } from 'mobx';
import moment from 'moment';
import { BasePreviewViewStore} from 'core/stores';
import {applicationContext} from 'core/utils';
import { TemplateService } from 'application/patient/services';
import _ from 'lodash';

@applicationContext
class TemplatePreviewViewStore extends BasePreviewViewStore {
    constructor(rootStore) {
        const id = rootStore.routerStore.routerState.params.templateId;
        super(rootStore, {
            name: 'template',
            autoInit: true,
            id: id,
            actions: () => {
                const service = new TemplateService(rootStore.application.baasic.apiClient);                                
                return {
                    get: async (id) => {
                        const response = await service.get(id);
                        let payors = _.groupBy(response.data.salesOrderInsuranceInfo.payors, function(item){
                            return item.payorLevel;
                        });
                        let maxPayors = [];
                        _.each(payors, (value, key) => {
                            if (key == 'Patient') return;
                            var firstPayor = _.first(_.sortBy(value, [function(o) { return( moment(o.effectiveDate, "DD/MM/YYYY")); }]));
                            maxPayors.push(firstPayor);
                        });
                        response.data.salesOrderInsuranceInfo.payors = maxPayors;
                        return response.data;
                    }
                }
            }
        });

        this.brightreeBaseUrl = this.rootStore.applicationStore.app.baasic.settings.brightreeBaseUrl;
    }

    @action.bound
    async getResource(id) {
        await super.getResource(id);
    }
}

export default TemplatePreviewViewStore;